import React, { useEffect } from "react";
import Link from "next/link";
import { useSelector } from "react-redux";
import Image from "next/image";

const FooterTop = () => {
  const headerFooterData = useSelector(
    (state) => state.headerFooterData.headerFooterDataList
  );

  useEffect(() => {
    console.clear();
  }, []);
  return (
    <div className="footer-top">
      <div className="footer-logo">
        <Link href="#" itemProp="logo">
          <Image
            src={
              headerFooterData &&
              headerFooterData?.site_configuration &&
              headerFooterData?.site_configuration[0]?.logo?.url
            }
            alt={
              (headerFooterData &&
                headerFooterData?.site_configuration &&
                headerFooterData?.site_configuration[0]?.logo?.alt_text) ||
              "Quixom logo"
            }
            height={300}
            width={300}
            loading="eager"
            priority
          />
        </Link>
      </div>
      <div className="footer-social-link">
        <ul>
          {headerFooterData?.social_media?.map((val, index) => {
            return (
              <li key={index} className={index + val.name}>
                <Link href={val?.url} itemProp="link">
                  <Image
                    src={val?.logo?.url}
                    alt={val?.logo?.alt_text ?? 'quixom'}
                    height={25}
                    width={25}
                    loading="eager"
                    priority
                    style={{ width: "auto", height: "auto" }}
                  />
                </Link>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default FooterTop;
